import {
  Badge,
  Button,
  IconButton,
  Popover,
  PopoverProps
} from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons';
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import BoardColumnMenu from '../../secure-portal/tasks/board/BoardColumnMenu';
import { TaskEntity } from '../../secure-portal/tasks/Task.interface';
import { getCartIndex, useCartContext } from './CartContext';

const StyledButtonContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0 12px 12px 12px;
`;

const CartIconBadge: React.FC<{
  taskEntity?: TaskEntity;
  onChange?: (taskEntity: TaskEntity) => void;
}> = ({ taskEntity, onChange }) => {
  const taskEntityRef = useRef(taskEntity);
  const onChangeRef = useRef(onChange);
  const { cart, clearCart, processedEntities, setProcessedEntities } =
    useCartContext();
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement>();
  const [popoverProps, setPopoverProps] = useState<Partial<PopoverProps>>({});
  useEffect(() => void (taskEntityRef.current = taskEntity), [taskEntity]);
  useEffect(() => {
    const index = taskEntityRef.current
      ? getCartIndex(processedEntities, taskEntityRef.current)
      : -1;
    const taskEntity = processedEntities[index];
    if (taskEntity && taskEntityRef.current) {
      taskEntityRef.current.task = taskEntity.task;
      onChangeRef.current?.({ ...taskEntity });
    }
  }, [processedEntities]);
  if (cart.length === 0) return null;
  return (
    <>
      <IconButton
        className='cart-button'
        size='small'
        color='secondary'
        onClick={event => setAnchorElement(event.currentTarget)}
      >
        <Badge badgeContent={cart.length} color='error'>
          <ShoppingCart />
        </Badge>
      </IconButton>
      {anchorElement && (
        <Popover
          open
          anchorEl={anchorElement}
          onClose={() => setAnchorElement(undefined)}
          {...popoverProps}
        >
          <BoardColumnMenu
            taskEntities={cart}
            onRender={() => {
              setPopoverProps({
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'right'
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'right'
                }
              });
            }}
            onChange={processedEntities => {
              if (processedEntities) {
                setProcessedEntities(processedEntities);
              }
              setAnchorElement(undefined);
            }}
          />
          <StyledButtonContainer>
            <Button
              fullWidth
              variant='outlined'
              color='primary'
              size='small'
              onClick={() => clearCart()}
            >
              Clear Cart
            </Button>
          </StyledButtonContainer>
        </Popover>
      )}
    </>
  );
};

export default CartIconBadge;
